/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_iw_robinson = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Robinson`)
};

const es_iw_robinson = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Robinson`)
};

const de_iw_robinson = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Robinson`)
};

const nl_iw_robinson = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Robinson`)
};

const fr_iw_robinson = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Robinson`)
};

const it_iw_robinson = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Robinson`)
};

const pt_br2_iw_robinson = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Robinson`)
};

const pt_iw_robinson = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Robinson`)
};

const ja_iw_robinson = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ロビンソン式`)
};

const zh_iw_robinson = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Robinson`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const iw_robinson = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.iw_robinson(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("iw_robinson", locale)
	if (locale === "en") return en_iw_robinson(inputs)
	if (locale === "es") return es_iw_robinson(inputs)
	if (locale === "de") return de_iw_robinson(inputs)
	if (locale === "nl") return nl_iw_robinson(inputs)
	if (locale === "fr") return fr_iw_robinson(inputs)
	if (locale === "it") return it_iw_robinson(inputs)
	if (locale === "pt-BR") return pt_br2_iw_robinson(inputs)
	if (locale === "pt") return pt_iw_robinson(inputs)
	if (locale === "ja") return ja_iw_robinson(inputs)
	return zh_iw_robinson(inputs)
};